import React from 'react';
import { injectIntl } from 'react-intl';
import { isNotEmpty, i18nIntl } from '../../lib/ep';

import PrizesPageItem from './PrizesPageItem';

import VideoEmbed from '../front/VideoEmbed';

import WinnerCup from '../svg/WinnerCup';
import LeveledHTMLText from '../front/helpers/LeveledHTMLText';
import SearchField from '../builder/SearchField';

const PrizesPageFlex = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const prizeSection = props.prizeSection;
	const prizes = props.prizes;

	const has_image = (prizeSection.win_img != undefined) ? true : false;
	const has_video = (isNotEmpty(prizeSection, 'win_video')) ? true : false;
	const description = (prizeSection.win_desc == '') ? `<h1>${i18n("Congratulations!")}</h1><p>${i18n("These are the winners and their prizes.")}</p>` : prizeSection.win_desc;

	return (
		<div class="flex_cols">
			{(has_image || has_video) && (
				<div class="flex_col col_1">
					<div class="mod_align_center main_media_flex">
						{(has_image && prizeSection.win_img != 'winner_cup' && prizeSection.win_img != '') && (
							<div class="main_img_promo">
								<img src={prizeSection.full_win_img} class="img" />
							</div>
						)}

						{/*((has_image && prizeSection.win_img == 'winner_cup') || prizeSection.win_img == '') && (
							<div class="main_img_promo">
								<WinnerCup />
							</div>
						)*/}

						{(has_video) && (
							<VideoEmbed
								page='prizes'
								promotion_id={props.promotion_id}
								video_url={prizeSection.win_video.url}
								video_thumb={prizeSection.win_video.thumbnail_url}
							/>
						)}
					</div>
				</div>
			)}

			<div class="flex_col col_2">
				<div class="winners_content gui_public_content">
					<div class="mod_align_center promo_desc gui_main_text_color_on_bg main_text_flex">
						<LeveledHTMLText>{description}</LeveledHTMLText>
					</div>

					<div class="winners_display">
						{(prizeSection.win_search != undefined && prizeSection.win_search != '0') && (
							<div class="gui_search_input">
								<SearchField
									_class={{ first:true }}
									name="search"
									change={props.searchAction}
									placeholder="Type to find winners"
								/>
							</div>
						)}

						<ul id="prize_list" class="prize_list">
							{prizes.map((p, i) => {
								if(p.public == 0) return '';
								if(props.search != '' && (p.Prize.length == 0 && p.Alternate.length == 0)) return '';

								return (
									<PrizesPageItem
										key={i}
										prize={p}
										win_display={prizeSection.win_display}
										public_entries={prizeSection.public_entries}
										onClick={(e) => props.clickPrize(p.id)}
										updatePrize={(prize) => props.updatePrize(prize)}
									/>
								)
							})}
						</ul>
					</div>
				</div>
			</div>
		</div>
	)
}

export default injectIntl(PrizesPageFlex);